module.exports = __webpack_public_path__ + "static/media/downloadIcon.a746d475.svg";